import { render, staticRenderFns } from "./AllInquiries.vue?vue&type=template&id=77fbb0d9&scoped=true&"
import script from "./AllInquiries.vue?vue&type=script&lang=js&"
export * from "./AllInquiries.vue?vue&type=script&lang=js&"
import style0 from "./AllInquiries.vue?vue&type=style&index=0&id=77fbb0d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77fbb0d9",
  null
  
)

export default component.exports